<div class="outer">
  <div class="inner bg">
    <div class="content" #content>
      <h1 class="title">ABOUT</h1>
      <div class="frame" [ngClass]="{'animateIn': triggerAnimation}">
        <p *ngFor="let paragraph of paragraphs$ | async">{{paragraph}}</p>
      </div>
    </div>
  </div>
</div>
